import { ProvinceUpdatePage } from "@/features/geolocation/page/ProvinceUpdate";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/province/$id/update")({
  component: ProvinceUpdatePage,
});
